import React, { useEffect } from "react";
import Footer from "../../../components/footer";
import Navbar from "../../../components/navbar";
import LiveTournaments from "./tournaments-section/live";
import ShowPotential from "./tournaments-section/potential";
import TournamentsHeroSection from "./tournaments-section/hero";

function Tournaments() {
  useEffect(() => {
    document.title = "Live Tournaments";
    if (window.location.hash === "#join-tournaments-section") {
      const el = document.getElementById("join-tournaments-section");
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, []);

  return (
    <>
      <Navbar />
      <TournamentsHeroSection />
      <LiveTournaments />
      <ShowPotential />
      <Footer />
    </>
  );
}

export default Tournaments;
